import { render, staticRenderFns } from "./dyh-wangEditor.vue?vue&type=template&id=3bd25889&"
import script from "./dyh-wangEditor.vue?vue&type=script&lang=js&"
export * from "./dyh-wangEditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports